const translations = {
	en: {
		upsellingBanner: {
			promoText: "You might also like this",
			linkText: "Discover more styles now",
		},
		classicMapConfig: {
			address: "Address",
			labelDescription:
				"For multi marker, separate entries with a comma. <%TEXT%> adds a badge with TEXT after the name.",
			priority: "Display level",
			anchor: "Alignment",
		},
	},
	de: {
		upsellingBanner: {
			promoText: "Das könnte Ihnen auch gefallen",
			linkText: "Jetzt <br>mehr Styles<br> entdecken",
		},
		classicMapConfig: {
			address: "Adresse",
			labelDescription:
				"Bei Multimarker werden mehrere Einträge mit , separiert. <%TEXT%> stellt hinter dem Namen eine Auszeichnung mit dem TEXT dar.",
			priority: "Anzeigelevel",
			anchor: "Ausrichtung",
		},
	},
};

const language = window.ocm?.config?.language || "de";

export const translate = ((language) => translations[language] || translations["en"])(language);
